const views = {
  ['DEFAULT']: () => ({
    bodyText:
      "To turn on your Zap, you'll need access to more Zaps. Turn off some of your other Zaps or upgrade now to turn on this Zap.",
    type: 'DEFAULT',
  }),

  ['TRIAL_EXTENSION']: () => ({
    bodyText:
      "To turn on your Zap, you'll need access to more Zaps. Upgrade now or start a free 7-day trial of the Professional plan to use unlimited Zaps.",
    type: 'TRIAL_EXTENSION',
  }),
};

type Props = {
  canExtendTrial: boolean;
};

export const getActiveView = ({ canExtendTrial }: Props) =>
  canExtendTrial ? views.TRIAL_EXTENSION() : views.DEFAULT();
